import { render, staticRenderFns } from "./LavLomStatusList.vue?vue&type=template&id=aa11016c"
import script from "./LavLomStatusList.vue?vue&type=script&lang=js"
export * from "./LavLomStatusList.vue?vue&type=script&lang=js"
import style0 from "./LavLomStatusList.vue?vue&type=style&index=0&id=aa11016c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports